<template>
    <b-nav tabs>
        <b-nav-item exact to="/login"> Iniciar Sesión </b-nav-item>    
    </b-nav>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    .nav-item a{
        color:#00AC89;
    }
</style>